export default function(callback) {

    this._attributer = callback;

    return this;
};
